export const MESSAGES_ROOT = 'messages-root'
